import { Suspense } from 'react'
import AppRouter from './router'
import Loading from '@components/ui/Loading'
import './services/i18n'

function App() {
  return (
    <Suspense fallback={<Loading size="lg" text="加载中..." />}>
      <AppRouter />
    </Suspense>
  )
}

export default App 